import { createContext, createElement, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const FALLBACK = { contact_phone: "+91 72492 86712", whatsapp: "917249286712", central_phone: "", central_email: "reservations@theanatahotales.com", offer: { active: false } };
const ConfigCtx = createContext(FALLBACK);

const cached = () => {
  try {
    return { ...FALLBACK, ...JSON.parse(localStorage.getItem("ananta-config") || "{}") };
  } catch {
    return FALLBACK;
  }
};

export const ConfigProvider = ({ children }) => {
  const [cfg, setCfg] = useState(cached);
  useEffect(() => {
    api.get("/config").then((r) => {
      setCfg(r.data);
      localStorage.setItem("ananta-config", JSON.stringify(r.data));
    }).catch(() => {});
  }, []);
  return createElement(ConfigCtx.Provider, { value: cfg }, children);
};

export const useConfig = () => useContext(ConfigCtx);
